import SEO from "../components/SEO/Seo";

import Header from "../components/Header/Header";
import Hero from "../components/Hero/Hero";
import Features from "../components/Features/Features";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import WhyUs from "../components/WhyUs/WhyUs";
import Pricing from "../components/Pricing/Pricing";
import Footer from "../components/Footer/Footer";
import ConnectExpert from "../components/Connect/ConnectExpert";
const LandingPage = () => {
  return (
    <>
      <SEO
        title="High Converting Landing Page"
        titleTemplate="Build High Converting Landing Pages"
        description="Create high converting landing pages with fast performance, modern UI, mobile first design and SEO optimization to increase traffic, leads and business growth."
        keywords="react landing page, seo friendly landing page, high converting landing page, react website development, modern landing page design, fast react website, business landing page"
      />

      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <WhyUs />
      <Pricing />
      <ConnectExpert />
      <Footer />
    </>
  );
};

export default LandingPage;
